import { type Grade } from './Grade'

export enum RasnChannel {
  DIGITAL = 'DIGITAL',
  NON_DIGITAL = 'NON_DIGITAL',
  WHOLESALE = 'WHOLESALE',
  RETAIL = 'RETAIL'
}

export enum RasnStatus {
  OPEN = 'OPEN',
  IN_RECEIVING = 'IN_RECEIVING',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export interface Rasn {
  number: string
  channel: RasnChannel
  holdCode: string
  customerName: string
  status: RasnStatus
  totalHandledUnits: number
  totalExpectedUnits: number
  created: number
  lastModified: number
  rasnFamilyId?: string
}

export enum RasnEventType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  UNLOCKED = 'UNLOCKED',
  CLOSED = 'CLOSED',
  INITIAL_RECEIPT = 'INITIAL_RECEIPT',
  PARTIAL_RECEIPT = 'PARTIAL_RECEIPT',
  FULL_RECEIPT = 'FULL_RECEIPT'
}

export interface RasnEvent {
  id: number
  type: RasnEventType
  externalId: string
  version: number
  timestamp: Date
  isSuccess: boolean
  canRetrigger: boolean
}

export interface RasnDetails {
  number: string
  channel: RasnChannel
  holdCode: string
  customerName: string
  status: RasnStatus
  totalExpectedUnits: number
  totalHandledUnits: number
  skus: RasnSku[]
  units: RasnUnit[]
  goodsholders: RasnGoodsholder[]
  extendedAttributes: Record<string, string>
  rasnFamilyId?: string
  boundless: boolean
  kickout: boolean
  emptyBox: boolean
}

export interface RasnSku {
  sku: string
  upc: string
  hashable: boolean
  division: string
  silhouette: string
  expectedQuantity: number
  actualQuantity: number
  resolved: boolean
}

export interface RasnUnit {
  sku: string
  upc: string
  division: Division
  silhouette: string
  hashable: boolean
  quantity: number
  coo: string
  grade: Grade
  simpleGrade: string
  gradeReason: string
  unitHandlingStation: string
  receivedGoodsHolder: string
  tote: string
  status: UnitStatus
  modifiedBy: string
  modifiedTimestamp: number
}

export interface RasnGoodsholder {
  lpn: string
  trackingId?: string | null
  expectedQuantity: number
  actualQuantity: number
  status: string
  modifiedBy: string
  modifiedTimestamp: number
}

export interface RasnEventPayload {
  payload: string
}

export enum Division {
  APPAREL,
  FOOTWEAR,
  EQUIPMENT
}

export enum GoodsholderStatus {
  'OPEN',
  'INITIALIZED',
  'CLOSED'
}

export enum UnitStatus {
  SCANNED = 'SCANNED',
  GRADED = 'GRADED',
  REWORKED = 'REWORKED',
  HANDLED = 'HANDLED',
  UNKNOWN = 'UNKNOWN',
}
